import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class RfpChatService extends BaseService {

    static url = "rfp_chats";
    loader = false;
    static apis = {
        that: this,
        getSpecific: {path: function(customerId, rfpId) {
            return "rfp_chats/" + customerId + "/" + rfpId
        }, method: "GET"},
        getChatMessages: {path: function(chatId) {
            return "rfp_chats/"+chatId+"/messages"
        }}
    }

    constructor(repo, loader = false) {
        super(repo);
        this.repo = new ApiHelper("customers");
        this.loader = loader
    }

    getChatMessages(chatId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: RfpChatService.apis.getChatMessages.path(chatId), method: "GET", authorization:false, showLoader: this.loader})
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getSpecific(customerId, rfpId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: RfpChatService.apis.getSpecific.path(customerId, rfpId), method: RfpChatService.apis.getSpecific.method, authorization:true, showLoader: this.loader})
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default RfpChatService;